import { useState } from "react"
import { Button, Flex, Modal } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import { spacings } from "themes/variables"
import { Text } from "ui/Typography"
import PropTypes from "prop-types"
import ClientContactForm from "../ClientsContactWindow"
import { routes } from "router"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import useActiveGuide from "hooks/useActiveClient"

const BulkActions = ({ clients, selectedRowKeys, setSelectedRowKeys, onGroupAction, canEditClient }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(false)
  const [contactType, setContactType] = useState("")
  const title = t("global.send") + " " + t(`client.${contactType}`)
  const { metadata } = useSelector((store) => store.clients)
  const { isActive: active } = useActiveGuide()

  const handleMenuClick = (type) => {
    const templates = metadata[`${type}_templates_collection`]

    setContactType(type)
    switch (type) {
      case "email":
        navigate(routes.guideClientEmailActionPath(), { state: { clients, userIds: selectedRowKeys, templates } })
        break
      case "text":
        navigate(routes.guideClientTextActionPath(), { state: { clients, userIds: selectedRowKeys, templates } })
        break
      default:
        navigate(routes.guideClientMessageActionPath(), { state: { clients, userIds: selectedRowKeys, templates } })
    }
  }

  const handleClose = () => {
    setIsVisible(false)
    setContactType("")
  }

  return (
    <>
      <Flex align="center" wrap="wrap" className={`py-s px-l mb-s position-relative ${styles.bulkActionsContainer}`} gap={spacings["XS"]}>
        <Text className={styles.selectedText}>{t("clients.selected", { count: selectedRowKeys.length })}</Text>
        <Flex gap={spacings["XS"]} className="ml-auto" wrap="wrap" align="flex-start">
          <Button
            color="primary"
            variant="outlined"
            className="px-l"
            onClick={active && canEditClient ? () => onGroupAction("bulk_remove", selectedRowKeys) : undefined}
            disabled={!active || !canEditClient}
          >
            {t("clients.bulk_actions.remove_from_group")}
          </Button>
          <Button
            color="primary"
            variant="outlined"
            className="px-l"
            onClick={active && canEditClient ? () => onGroupAction("bulk_add", selectedRowKeys) : undefined}
            disabled={!active || !canEditClient}
          >
            {t("clients.bulk_actions.add_to_group")}
          </Button>
          <Button
            color="primary"
            variant="outlined"
            className="px-l"
            onClick={active ? () => handleMenuClick("email") : undefined}
            disabled={!active}
          >
            {t("clients.bulk_actions.email_selection")}
          </Button>
          <Button
            color="primary"
            variant="outlined"
            className="px-l"
            onClick={active ? () => handleMenuClick("message") : undefined}
            disabled={!active}
          >
            {t("clients.bulk_actions.message_selection")}
          </Button>
          <Button
            color="primary"
            variant="outlined"
            className="px-l"
            onClick={active ? () => handleMenuClick("text") : undefined}
            disabled={!active}
          >
            {t("clients.bulk_actions.text_selection")}
          </Button>
          <Button
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            className={styles.closeButton}
            onClick={() => setSelectedRowKeys([])}
          />
        </Flex>
      </Flex>

      <Modal title={title} width={{ xxl: 800, xl: 600, xs: 400 }} open={isVisible} footer={null} onCancel={handleClose} destroyOnClose>
        <ClientContactForm
          handleClose={handleClose}
          type={contactType}
          clients={clients}
          userIds={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </Modal>
    </>
  )
}

BulkActions.propTypes = {
  clients: PropTypes.array,
  selectedRowKeys: PropTypes.array,
  setSelectedRowKeys: PropTypes.func,
  onGroupAction: PropTypes.func,
  canEditClient: PropTypes.bool
}

export default BulkActions
